export function header() {
  mobileMenuBtnsHandler();
  showSubmenuHandler();
}

function mobileMenuBtnsHandler() {

  const burger = document.getElementById('burger');
  const closeBtn = document.getElementById('mobile-menu__close');

  if (!burger) return;

  burger.addEventListener('click', toggleMobileMenu);
  if (closeBtn) {
    closeBtn.addEventListener('click', toggleMobileMenu);
  }

}

function toggleMobileMenu() {
  const mobileMenuWrapper = document.getElementById('mobile-menu-wrapper');
  const burger = document.getElementById('burger');

  if (!mobileMenuWrapper) {
    return;
  }
  mobileMenuWrapper.classList.toggle('visible');
  document.body.classList.toggle('scroll-lock');
  burger.classList.toggle('active');
}

function showSubmenuHandler() {

  const mobileMenu = document.querySelector('#mobile-menu-wrapper > .root-menu__mobile');
  if (!mobileMenu) return;

  mobileMenu.addEventListener('click', (event) => {

    const target = event.target;
    console.log(target);

     if (target.closest('a[href^="/#"]')) {
      const burger = document.getElementById('burger');
      if (burger) burger.classList.toggle('active');
      document.querySelector('#mobile-menu-wrapper')?.classList.remove('visible');
      document.body.classList.toggle('scroll-lock');
      
      return;
    }


    const currentToggle = target.closest('.submenu-toggle');
    if (!currentToggle) return;

    const currentMenuWithChildren = currentToggle.closest('.menu-item-has-children');
    if (!currentMenuWithChildren) return;
    currentMenuWithChildren.classList.toggle('visible');
  });
}